import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useContext } from "react";

/**
 * Reads the per-team Reclaim async-onboarding flag from `team.featureFlags`.
 * Returns false until team data has loaded so the widget never renders
 * with stale or missing flag state.
 *
 * Centralized here so removing the flag at GA only touches one file.
 * When future products (returns, conversion) get their own setup guides
 * each gets its own LaunchDarkly flag and its own hook.
 */
export function useReclaimAsyncOnboardingEnabled(): boolean {
  const team = useContext(TeamContext);
  if (!team) return false;
  return (
    team.featureFlags?.[FeatureFlagKey.MERCHANT_RECLAIM_ONBOARDING_ASYNC] ===
    true
  );
}
